import { Messages } from './components/messages/Messages';
import './css/core.css';
import './css/elements.css';
import './css/reset.css';
import './css/variables.css';
import { BackendContextProvider } from './services/backend/backendContextProvider';
import { StrokeProvider } from './services/editor/editorContext';
import { Router } from './services/router/Router';
import { RouterContextProvider } from './services/router/routerContext';

function App() {
  return (
    <RouterContextProvider>
      
        <BackendContextProvider
          serverUrl="https://pipak.onrender.com"
          // serverUrl="http://localhost:3001"
          apiSlug="api"
          clientSlug="client"
        >

          <StrokeProvider>

          <Router />
          <Messages />

          </StrokeProvider>

        </BackendContextProvider>

      
    </RouterContextProvider>
  );
}

export default App;
